import React from 'react';
import PropTypes from 'prop-types';
import {Popup} from 'semantic-ui-react';

import Chip from '@ui/Chip';

/**
 * Display:
 * - yesValue for true (default Yes)
 * - noValue for false (default No)
 * - "-" for NULL
 * allow add red chip if valueHighlight defined and return value === valueHighlight
 *
 * @param value Value to compare
 * @param valueHighlight If return value === valueHighlight, we should add red chip
 * @param trueValue Value for Yes value (default 'Yes')
 * @param falseValue Value for No value (default 'No')
 * @returns {string|*}
 */
export const ValuesDashRedChip = ({
    options = {
        value: null,
        valueHighlight: null,
        trueValue: 'Yes',
        falseValue: 'No',
    },
}) => {
    const {value = null, valueHighlight = null, trueValue = 'Yes', falseValue = 'No'} = options;

    let returnValue = '';

    /**
     * No value (can be overwrite if noValue passed)
     */
    if (false === value) {
        returnValue = falseValue;
        /**
         * Yes value (can be overwrite if yesValue passed)
         */
    } else if (true === value) {
        returnValue = trueValue;
        /**
         * NULL - display "-"
         */
    } else if (null === value) {
        returnValue = '-';
    }

    /**
     * if we should add red chip on value
     */
    if (valueHighlight && valueHighlight === returnValue) {
        return <Chip size='small' color='error' label={returnValue} />;
    }

    return returnValue;
};

ValuesDashRedChip.propTypes = {
    options: PropTypes.shape({
        value: PropTypes.any,
        valueHighlight: PropTypes.string,
        trueValue: PropTypes.string,
        falseValue: PropTypes.string,
    }),
};

export const ValuesDashRedChipWithTooltip = ({
    options = {
        value: null,
        isRed: false,
        tooltip: '',
    },
}) => {
    const {value, isRed = false, tooltip = ''} = options;
    const trigger = (
        <span>
            {isRed && value ? <Chip size='small' color='error' label={value} /> : value ?? '-'}
        </span>
    );

    return !tooltip ? trigger : <Popup on='hover' content={tooltip} trigger={trigger}/>;
};

ValuesDashRedChipWithTooltip.propTypes = {
    options: PropTypes.shape({
        value: PropTypes.any,
        isRed: PropTypes.bool,
        tooltip: PropTypes.string,
    }),
};
